module.exports = __webpack_public_path__ + "img/thumb-medrespond.54e04ff6.jpg";